const TIPOS_MOMENTO_APLICACION_REGLAS = [
  {
    id: 1,
    name: 'En vigilancia',
  },
  {
    id: 2,
    name: 'En descarga',
  },
  {
    id: 3,
    name: 'En vigilancia y en descarga',
  },
]

export {
  TIPOS_MOMENTO_APLICACION_REGLAS
}

